import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../AuthContext'
import { API_BASE } from '../config'

// Captures a ?ref=CODE link into localStorage, then claims it once the user is
// logged in. The backend no-ops unless REFERRALS_ENABLED, so this is safe while off.
export default function ReferralCapture() {
  const { user } = useAuth()
  const location = useLocation()

  useEffect(() => {
    try {
      const ref = new URLSearchParams(window.location.search).get('ref')
      if (ref) localStorage.setItem('revive_ref', ref)
    } catch {}
  }, [location.search])

  useEffect(() => {
    if (!user?.token) return
    let ref
    try { ref = localStorage.getItem('revive_ref') } catch {}
    if (!ref) return
    fetch(`${API_BASE}/api/referral/claim`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${user.token}` },
      body: JSON.stringify({ code: ref }),
    }).then(() => { try { localStorage.removeItem('revive_ref') } catch {} }).catch(() => {})
  }, [user?.token])

  return null
}
